import { render } from "./02_NachhaltigerGrundriss.vue?vue&type=template&id=6a8de78d"
import script from "./02_NachhaltigerGrundriss.vue?vue&type=script&lang=js"
export * from "./02_NachhaltigerGrundriss.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__